<template>
    <div class="booking-plan-content" v-show="isShow">
        <div class="deck-plan-bg"></div>
        <div class="deck-plan-details">
            <div class="plan-details">
                <div class="plan-details-title">甲板图</div>
                <div class="details-content">
                    <div class="details-img js-smartScroll"><img :src="deckImage"></div>
                </div>
                <div class="deck-close" @click="closeBookingDeckPopup"><img src="https://resource.rcclchina.com.cn/cruiseDetail/closed.png"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BookingDeck",
    props: {
        shipCode: {
            type: String
        },
        sailDate: {
            type: String
        },
        deckNumber: {
            type: String
        },
        closeBookingDeckPopup: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        }
    },
    computed: {
        deckImage() {
            const imgUrl = process.env.VUE_APP_IMG_URL;
            if (!this.shipCode || this.shipCode.length == 0 || !this.deckNumber || this.deckNumber.length == 0) {
                return ''
            }
            let image = `${imgUrl}/DeckImages/${this.shipCode}${this.deckNumber}.jpg`
            // 2019QN特殊图片
            const sailDateTime = new Date(this.sailDate)
            if (this.shipCode == 'SC') {
                image = `${imgUrl}/DeckImages/${this.shipCode}${this.deckNumber}.jpg`
            } else if (this.shipCode == 'OV') {
                image = `${imgUrl}/DeckImages/2024/${this.shipCode}${this.deckNumber}.jpg`
            } else if (this.shipCode == 'QN' && sailDateTime.getTime() >= new Date('2019-01-01').getTime()) {
                image = `${imgUrl}/DeckImages/${this.shipCode}2019${this.deckNumber}.jpg`
            }
            return image
        },
    }
}
</script>

<style lang="less" scoped>
.booking-plan-content {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 100;
    .deck-plan-bg {
        position: relative;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: .8;
        top: 0;
        z-index: 20;
    }
    .deck-plan-details {
        position: absolute;
        top: 90px;
        width: 100%;
        padding: 0 10px;
        height: calc(100% - 130px);
        overflow: hidden;
        z-index: 20;
        .plan-details {
            background: #fff;
            height: 100%;
            padding: 0 5px;
            position: relative;
            .plan-details-title {
                width: 345px;
                text-align: center;
                height: 40px;
                line-height: 40px;
                border-bottom: 1px solid #eaeaea;
                color: #061556;
                font-size: 14px;
                font-weight: 600;
                overflow: hidden;
            }
            .details-content {
                position: relative;
                height: calc(100% - 40px);
                .details-img {
                    width: 100%;
                    border-right: 2px solid #e2e2e2;
                    height: 100%;
                    overflow-y: scroll;
                    img {
                        width: 100%;
                    }
                }
            }
            .deck-close {
                position: absolute;
                width: 25px;
                height: 25px;
                overflow: hidden;
                top: 5px;
                right: 5px;
                img {
                    width: 100%;
                }
            }
        }
    }
}
</style>
